import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiGet } from '../lib/api';
import { Badge } from '../lib/badge';
import Icon from './icons';

function Dashboard() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiGet('/dashboard/summary')
      .then(setData)
      .catch((e) => setErr(String(e)))
      .finally(() => setLoading(false));
  }, []);

  const t = data?.totals || {};

  const cards = [
    { label: 'Total Skills', value: t.skills, link: '/skills', icon: 'skills' },
    { label: 'Active Skills', value: t.active_skills, link: '/skills', icon: 'skills' },
    { label: 'Agents', value: t.agents, link: '/agents', icon: 'agents' },
    { label: 'Runs', value: t.runs, link: '/runs', icon: 'runs' },
    { label: 'Pending Approvals', value: t.pending_approvals, link: '/approvals', icon: 'approvals' },
    { label: 'Integrations', value: t.integrations, link: '/integrations', icon: 'integrations' },
    { label: 'Connected Integrations', value: t.connected_integrations, link: '/integrations', icon: 'integrations' },
    { label: 'Workspaces', value: t.workspaces, link: '/workspaces', icon: 'workspaces' },
    { label: 'Customers', value: t.customers, link: '/customers', icon: 'customers' },
  ];

  return (
    <main className="page">
      <div className="page__header">
        <span className="page__icon"><Icon name="dashboard" /></span>
        <div className="page__header-text">
          <h2>Executive Dashboard</h2>
          <p>Live control-plane metrics from the Enterprise Claude Skills API.</p>
        </div>
      </div>
      {err && <div className="status status--error">{err}</div>}
      {loading ? (
        <p className="status status--muted">Loading dashboard metrics…</p>
      ) : (
        <>
          <section className="metrics-grid">
            {cards.map((c) => (
              <Link key={c.label} to={c.link} className="metric-card">
                <span className="metric-card__icon"><Icon name={c.icon} /></span>
                <span className="metric-card__body">
                  <span className="metric-card__label">{c.label}</span>
                  <span className="metric-card__value">{c.value ?? 0}</span>
                </span>
              </Link>
            ))}
          </section>
          <section className="panel-grid">
            <article className="panel">
              <h3>Runs by State</h3>
              <ul className="simple-list">
                {(data?.runs_by_state || []).map((r) => (
                  <li key={r.state}>
                    <Badge value={r.state} />
                    <strong>{r.count}</strong>
                  </li>
                ))}
                {!(data?.runs_by_state || []).length && (
                  <li className="cell-muted">No runs yet.</li>
                )}
              </ul>
            </article>
            <article className="panel">
              <h3>Skills by Lifecycle</h3>
              <ul className="simple-list">
                {(data?.skills_by_lifecycle || []).map((r) => (
                  <li key={r.lifecycle}>
                    <Badge value={r.lifecycle} />
                    <strong>{r.count}</strong>
                  </li>
                ))}
              </ul>
            </article>
          </section>
          <p className="page__meta">
            Last updated: {data?.generated_at ? new Date(data.generated_at).toLocaleString() : '—'}
          </p>
        </>
      )}
    </main>
  );
}

export default Dashboard;
